import { PLL_IMAGES } from '../../Config/config'
import { createQRBaseUrl } from '../../Constants'
import { QueryParams, callFlowCodeAPI } from '../utils/request'

/**
 * Generate a QR code for a given link
 */
export async function createQRCode(link: string): Promise<string | null> {
  let body: { [key: string]: any } = {
    url: link,
    data_pattern_shape: 'circle',
    image_type: 'png',
    logo_image_height: 20,
    logo_image_width: 20,
    logo_image_url: PLL_IMAGES.pllAppLogo,
  }

  try {
    const res = await callFlowCodeAPI<any>(
      'GET',
      createQRBaseUrl, //Url for Flowcode API
      body as QueryParams
    )
    if (res) {
      return res
    }
    return null
  } catch (err) {
    console.log(err)
    return null
  }
}
